module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t("label_users")) + " [" + _vm._s(_vm.pagination.totalCount) + "]")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "filters-toolbar"
  }, [(!_vm.hiddenColumns.includes('DEBTOR')) ? _c('div', {
    staticClass: "filter-item"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.debtor),
      expression: "debtor"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.debtor) ? _vm._i(_vm.debtor, null) > -1 : (_vm.debtor)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.debtor,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.debtor = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.debtor = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.debtor = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t("label_users_show_only_debtor")))])])]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('MEMBERSHIP')) ? _c('div', {
    staticClass: "filter-item wide"
  }, [_c('div', {
    staticClass: "scrollmenuStartFilter"
  }, [_vm._l((_vm.expireFromMonthsList), function(item) {
    return _c('span', {
      key: item.value,
      staticClass: "chips-group",
      on: {
        "click": function($event) {
          return _vm.onClickExpireMonth(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip-filter"
    }, [_c('span', {
      class: _vm.getChipClassExpire(item)
    }, [_vm._v("\n                " + _vm._s(_vm.isSelectedExpire(item) ? '✔ ' : '') + _vm._s(item.label) + "\n              ")])])])
  }), _vm._v(" "), _c('span', {
    staticClass: "chips-group"
  }, [_c('span', {
    staticClass: "single-chip-filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.expireInDays),
      expression: "expireInDays",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "chip-input",
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": _vm.locale.t('label_expire_to_days')
    },
    domProps: {
      "value": (_vm.expireInDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expireInDays = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.allCustomCategories.length > 0) ? _c('div', {
    staticClass: "filter-item wide"
  }, [_c('div', {
    staticClass: "scrollmenu"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_choose_location')))]), _vm._v(" "), _vm._l((_vm.allCustomCategories), function(item) {
    return _c('span', {
      key: item,
      staticClass: "chips-group",
      on: {
        "click": function($event) {
          return _vm.clickSelectCustomCategory(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip-filter"
    }, [_c('span', {
      class: _vm.getChipClassCustomCategory(item)
    }, [_vm._v(_vm._s(_vm.isSelectedCustomCategory(item) ? '✔ ' : '') + _vm._s(item))])])])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.locale.t('label_choose_location_desc')))])]) : _vm._e(), _vm._v(" "), (_vm.partnerCompanies.length > 0) ? _c('div', {
    staticClass: "filter-item"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_company_partners')))]), _vm._v(" "), _c('div', {
    staticClass: "row-inline"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPartnerCompany),
      expression: "selectedPartnerCompany"
    }],
    staticClass: "form-control input",
    style: (_vm.isMobile() ? 'width: 90%' : 'width: 20%'),
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPartnerCompany = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_without_company_partners')))]), _vm._v(" "), _vm._l((_vm.partnerCompanies), function(item) {
    return _c('option', {
      key: item.name,
      domProps: {
        "value": item.name
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2), _vm._v(" "), (_vm.isVisiblePartnerReport) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.externalPartnerPdf()
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_download_report')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isEnableGender) ? _c('div', {
    staticClass: "filter-item"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_choose_gender')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedGender),
      expression: "selectedGender"
    }],
    staticClass: "form-control input",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedGender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_choose_gender')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_gender_male')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_gender_female')))])])]) : _vm._e(), _vm._v(" "), (_vm.loyaltyProgramsList.length > 0) ? _c('div', {
    staticClass: "filter-item wide"
  }, [_c('div', {
    staticClass: "scrollmenu"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_loyalty')) + ":")]), _vm._v(" "), _vm._l((_vm.loyaltyProgramsList), function(item) {
    return _c('span', {
      key: item,
      staticClass: "chips-group",
      on: {
        "click": function($event) {
          return _vm.clickSelectLoyalty(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip-filter"
    }, [_c('span', {
      class: _vm.getChipClassLoyalty(item)
    }, [_vm._v(_vm._s(_vm.isSelectedLoyalty(item) ? '✔ ' : '') + _vm._s(item))])])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-item"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_sort_by')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortBy),
      expression: "sortBy"
    }],
    staticClass: "form-control input",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sortBy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sortOptions), function(opt) {
    return _c('option', {
      key: opt.value,
      domProps: {
        "value": opt.value
      }
    }, [_vm._v(_vm._s(opt.label))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "filter-item"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_direction')))]), _vm._v(" "), _c('div', {
    staticClass: "direction-toggle"
  }, [_c('button', {
    class: ['dir-btn', {
      active: _vm.sortDir === 'asc'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.sortDir = 'asc'
      }
    }
  }, [_c('i', {
    staticClass: "ti-arrow-up"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_direction_up')))]), _vm._v(" "), _c('button', {
    class: ['dir-btn', {
      active: _vm.sortDir === 'desc'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.sortDir = 'desc'
      }
    }
  }, [_c('i', {
    staticClass: "ti-arrow-down"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_direction_down')))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.clickSearch()
      }
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v(_vm._s(_vm.locale.t("label_do_search")))])]), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [(!_vm.isMobile()) ? _c('th', {
    staticStyle: {
      "width": "0px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_serial_num')))]) : _vm._e(), _vm._v(" "), (_vm.useProfilePictures) ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_picture")))]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('NAME')) ? _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_name')) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('CREATE_TIMESTAMP')) ? _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_registered')) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('BIRTHDAY')) ? _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_birthday')) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('NUMBER_OF_TRAININGS')) ? _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_trainings')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.additionalTypes.length > 0) ? _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_additional_payment')) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('NOT_COMING')) ? _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_number_of_not_arrived')) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('PAID')) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_paid')) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('EXPIRE')) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_expire')) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('LOYALTY') && _vm.loyaltyProgramsList.length > 0) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_loyalty')) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('SHOES_SIZE')) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_shoes_size')) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('PARTNER')) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.capitalizeFirstLetter(_vm.namesForPartner)) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('EXTERNAL_PAR')) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_company_partners')) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('PAYMENT_TYPE')) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_payment_type')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.visibleCustomConfig) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.customCategory) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('BUTTON_PAYMENTS')) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payments')) + "\n              ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsers), function(user, index) {
    return _c('tr', {
      style: (_vm.getUserStyleTr(user))
    }, [(!_vm.isMobile()) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_serial_num')
      }
    }, [_vm._v(_vm._s(index + 1))]) : _vm._e(), _vm._v(" "), (_vm.useProfilePictures) ? _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_picture')
      }
    }, [(user.profilePicture != null && user.profilePicture.length > 0) ? _c('img', {
      staticClass: "cropped1 user-avatar-sm",
      attrs: {
        "src": user.profilePicture
      },
      on: {
        "click": function($event) {
          return _vm.openImage(user.profilePicture, user.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), (user.profilePicture == null || user.profilePicture.length === 0) ? _c('img', {
      staticClass: "cropped1-missing user-avatar-sm",
      attrs: {
        "src": require("../../../assets/img/icons/missing_image.svg")
      },
      on: {
        "click": function($event) {
          return _vm.openImage('', user.id)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('NAME')) ? _c('td', {
      style: (_vm.getDebtorStyle(user)),
      attrs: {
        "data-title": _vm.locale.t('label_name')
      },
      on: {
        "click": function($event) {
          return _vm.onClickUser(user)
        }
      }
    }, [_vm._v("\n                " + _vm._s(user.name) + " " + _vm._s(user.surname) + "\n                " + _vm._s(user.role === 'ROLE_TRAINER' ? '(' + _vm.locale.t('label_role_trainer').charAt(0) + ')' : '') + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('CREATE_TIMESTAMP')) ? _c('td', {
      style: (_vm.getDebtorStyle(user)),
      attrs: {
        "data-title": _vm.locale.t('label_registered')
      },
      on: {
        "click": function($event) {
          return _vm.onClickUser(user)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.formatDate(user.createdTimestamp)) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('BIRTHDAY') && ((_vm.isMobile() && _vm.visibleUsersId.includes(user.id)) || !_vm.isMobile())) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_birthday')
      }
    }, [_vm._v("\n                " + _vm._s(user.birthday != null ? _vm.formatDate(user.birthday) : '/') + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('NUMBER_OF_TRAININGS') && ((_vm.isMobile() && _vm.visibleUsersId.includes(user.id)) || !_vm.isMobile())) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_trainings')
      }
    }, [_vm._v("\n                " + _vm._s(user.restOfTraining) + "\n                "), _c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.setTrainingNumber(user.id, user.restOfTraining)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    })])]) : _vm._e(), _vm._v(" "), (_vm.additionalTypes.length > 0 && ((_vm.isMobile() && _vm.visibleUsersId.includes(user.id)) || !_vm.isMobile())) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_additional_payment')
      }
    }, [_vm._v("\n                " + _vm._s(user.additionalServiceCount != null ? user.additionalServiceCount : '0') + "\n                "), _c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.setAdditionalServices(user.id, user.additionalServiceCount != null ? user.additionalServiceCount : '0')
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    })])]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('NOT_COMING') && ((_vm.isMobile() && _vm.visibleUsersId.includes(user.id)) || !_vm.isMobile())) ? _c('td', {
      style: (_vm.getNotArrivalStyle(user.notArrival)),
      attrs: {
        "data-title": _vm.locale.t('label_number_of_not_arrived')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.removeNotArrival(user.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-minus"
    })]), _vm._v("\n                " + _vm._s(user.notArrival) + "\n                "), _c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.addNotArrival(user.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-plus"
    })])]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('PAID') && ((_vm.isMobile() && _vm.visibleUsersId.includes(user.id)) || !_vm.isMobile())) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_paid')
      },
      on: {
        "click": function($event) {
          return _vm.onClickUser(user)
        }
      }
    }, [_vm._v(_vm._s(_vm.formatDate(user.paidDate)) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('EXPIRE') && ((_vm.isMobile() && _vm.visibleUsersId.includes(user.id)) || !_vm.isMobile())) ? _c('td', {
      style: (_vm.getStyleActiveMembership(user)),
      attrs: {
        "data-title": _vm.locale.t('label_expire')
      },
      on: {
        "click": function($event) {
          return _vm.onClickUser(user)
        }
      }
    }, [_vm._v(_vm._s(_vm.formatDate(user.expireDate)) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('LOYALTY') && _vm.loyaltyProgramsList.length > 0 && ((_vm.isMobile() && _vm.visibleUsersId.includes(user.id)) || !_vm.isMobile())) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_loyalty')
      },
      on: {
        "click": function($event) {
          return _vm.onClickUser(user)
        }
      }
    }, _vm._l((_vm.loyaltyProgramsList), function(item) {
      return _c('span', {
        staticClass: "loyalty-badge-item"
      }, [_c('p', {
        style: (_vm.loyaltyStyle(item, user.paidMonthsInRow))
      }, [_vm._v(_vm._s(user.paidMonthsInRow > item ? item : user.paidMonthsInRow) + "/" + _vm._s(item))])])
    }), 0) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('SHOES_SIZE') && ((_vm.isMobile() && _vm.visibleUsersId.includes(user.id)) || !_vm.isMobile())) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_shoes_size')
      }
    }, [_vm._v("\n                " + _vm._s(user.shoesSize != null ? user.shoesSize : '/') + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('PARTNER') && ((_vm.isMobile() && _vm.visibleUsersId.includes(user.id)) || !_vm.isMobile())) ? _c('td', {
      attrs: {
        "data-title": _vm.capitalizeFirstLetter(_vm.namesForPartner)
      }
    }, [_vm._v("\n                " + _vm._s(user.companyPayment != null && user.companyPayment !== '' ? user.companyPayment : '/') + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('EXTERNAL_PAR') && ((_vm.isMobile() && _vm.visibleUsersId.includes(user.id)) || !_vm.isMobile())) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_company_partners')
      }
    }, [_vm._v("\n                " + _vm._s(user.partnerCompany != null && user.partnerCompany !== '' ? user.partnerCompany : '/') + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('PAYMENT_TYPE') && ((_vm.isMobile() && _vm.visibleUsersId.includes(user.id)) || !_vm.isMobile())) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_payment_type')
      },
      on: {
        "click": function($event) {
          return _vm.onClickTrainingTypes(user)
        }
      }
    }, [_vm._v("\n                " + _vm._s(user.trainingTypes) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.visibleCustomConfig && ((_vm.isMobile() && _vm.visibleUsersId.includes(user.id)) || !_vm.isMobile())) ? _c('td', {
      attrs: {
        "data-title": _vm.customCategory
      }
    }, [_vm._v("\n                " + _vm._s(user.customCategory) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('BUTTON_PAYMENTS') && ((_vm.isMobile() && _vm.visibleUsersId.includes(user.id)) || !_vm.isMobile())) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_payments')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.paymentUser(user)
        }
      }
    }, [_c('i', {
      staticClass: "ti-money"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_payments')) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.isMobile()) ? _c('td', [_c('show-more', {
      on: {
        "update:selectedModel": function($event) {
          return _vm.onupdate($event, user)
        }
      }
    })], 1) : _vm._e()])
  }), 0)])])])]), _vm._v(" "), (_vm.pagination.totalCount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pagination', {
    attrs: {
      "active-page": _vm.pagination.page,
      "total": _vm.pagination.totalCount,
      "limit": _vm.pagination.limit
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('show-image-dialog', {
    attrs: {
      "show": _vm.showImagePreview,
      "image": _vm.imageToPreview,
      "userId": _vm.imageToPreviewUserId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9e166a56!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/EmployedUsers/EmployedUsers.vue
// module id = 809
// module chunks = 0